import React, { useState } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, reset } from "redux-form";
import { NotificationManager } from "react-notifications";

import FilterPanel, { PanelBody, PanelFooter } from "../../../sharedComponents/filterPanel";
import { required } from "../../../constants/formValidators";
import { FormField } from "../../../sharedComponents/formField";
import { addTestimonials } from "../../../store/actions";

const AddTestimonial = ({ toggleAddTestimonial, setToggleAddTestimonial, handleSubmit, onAdd, addTestimonials, resetForm }) => {
	const [submitting, setSubmitting] = useState(false);

	const addTestimonial = (values) => {
		setSubmitting(true);
		const successHandler = (event) => {
			if (event.status >= 200 && event.status < 300) {
				NotificationManager.success("Successfully added testimonial", "", 5000);
				resetForm("AddTestimonialForm");
				onAdd && onAdd();
				setToggleAddTestimonial(false);
			} else {
				NotificationManager.error("Please try again!", "", 5000);
			}
		};

		values.fulltext && values.fulltext !== ""
			? addTestimonials(values, successHandler)
			: NotificationManager.error("Please add notes!", "", 5000);
	};

	return (
		<FilterPanel
			className="add-testimonial-panel hide-sub-header"
			show={toggleAddTestimonial}
			toggle={(event) => {
				setToggleAddTestimonial(event);
				resetForm("AddTestimonialForm");
			}}
			title={"Submit Your Success Story "}
			closeBtn>
			<form onSubmit={handleSubmit(addTestimonial)}>
				<PanelBody>
					<h4 className="text-primary-dark"> Inspire others with your story!</h4>
					<p>
						It may be helpful to have your story written and edited before posting. Just cut and paste the text
						below. Do not worry about formatting, we will take care of that. So please; just cut and paste text.
					</p>
					<div className="row">
						<Field
							name="fulltext"
							validate={[required]}
							type="textarea"
							formGroupClass="col-12"
							component={FormField}
							onChange={() => setSubmitting(false)}
						/>
					</div>
				</PanelBody>
				<PanelFooter className="pt-0 pb-0">
					<div className="text-right pt-3 pb-3">
						<button
							className="btn btn-default"
							type="button"
							onClick={() => {
								setToggleAddTestimonial(false);
								resetForm("AddTestimonialForm");
							}}>
							Cancel
						</button>
						<button className="btn btn-primary-dark text-uppercase" type="submit" disabled={submitting}>
							Save Testimonial
						</button>
					</div>
				</PanelFooter>
			</form>
		</FilterPanel>
	);
};

const mapDispatchToProps = { addTestimonials, resetForm: reset };

export default reduxForm({
	form: "AddTestimonialForm"
})(
	connect(
		null,
		mapDispatchToProps
	)(AddTestimonial)
);
